import React from "react";

import InfoIcon from "@material-ui/icons/Info";
import { InputNumber } from "antd";
import styled from "styled-components/macro";

import { Tooltip } from "components/base";

import {
  midstreamNavigatorActions,
  useMidstreamNavigatorContext
} from "../context/MidstreamNavigatorContext";

const MinContributionPercentInput: React.FC = () => {
  const [state, dispatch] = useMidstreamNavigatorContext();

  const handleChange = (value: number | null) => {
    // Allow null to clear the filter, but validate range for numeric values
    if (value === null || (value >= 0 && value <= 100)) {
      dispatch(midstreamNavigatorActions.setMinContributionPercent(value));
    }
  };

  return (
    <Container>
      <TextContain>
        <label>Min Contribution (%)</label>
        <Tooltip title="Hide table rows with Contribution % below this value">
          <StyledIcon />
        </Tooltip>
      </TextContain>

      <StyledInput
        type="number"
        placeholder="0"
        value={state.minContributionPercent}
        min={0}
        max={100}
        controls={false}
        data-testid="min-contribution-percent-input"
        onChange={(val: string | null | number) => {
          if (val === null || val === "") {
            handleChange(null);
            return;
          }
          handleChange(Number(val));
        }}
      />
    </Container>
  );
};

export default MinContributionPercentInput;

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
  flex-direction: column;
  cursor: default;
  flex-grow: 1;
`;

const TextContain = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

const StyledIcon = styled(InfoIcon)`
  color: #a2aaad;
  margin-right: auto;
`;

const StyledInput = styled(InputNumber)`
  width: 100%;
  border-radius: 6px;

  &:hover {
    border-color: var(--color-primary);
  }

  &.ant-input-number-focused {
    border-color: var(--color-primary-hover);
    box-shadow: 0 0 0 2px rgba(var(--color-primary-rgb), 0.3);
  }
`;
